import styled from "styled-components"
import {HiPlus} from "react-icons/hi"
import { useDispatch } from "react-redux"
import { addRouteItem } from "../../../../../features/updateLoad/updateLoadSlice"
import { useSelector } from "react-redux"

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: underline !important;
    color: ${({theme}) => theme.secondaryTextColor};
    cursor: pointer;
    margin-bottom: ${({SelectLoadMap}) => SelectLoadMap && "15px"};

    .text{
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        padding-left: 20px;
    }

    .circle-container{
      width: 20px;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      display: ${({SelectLoadMap}) => SelectLoadMap && "none"};
    }
`

const AddRoute = ({order=2, type="yukleme",SelectLoadMap}) => {

  const {theme} = useSelector(state => state.layout)

  const dispatch = useDispatch()

  const handleClick = () => {
    
    if(type === "yukleme"){
      dispatch(addRouteItem({type: "yukleme" }))
    }

    if(type === "bosaltma"){
      dispatch(addRouteItem({type: "bosaltma" }))
    }
  }

  return (
    <Container SelectLoadMap={SelectLoadMap} onClick={handleClick}>
      <div className="circle-container">
       <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7.5" cy="7.5" r="7" transform="matrix(-1 0 0 1 15 0)" fill="white" stroke="#3C3C3B"/>
        </svg>
      </div>
      <div className="text">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: "10px"}}>
          <path d="M5.75 0C5.94891 0 6.13968 0.0790175 6.28033 0.21967C6.42098 0.360322 6.5 0.551088 6.5 0.75V5H10.75C10.9489 5 11.1397 5.07902 11.2803 5.21967C11.421 5.36032 11.5 5.55109 11.5 5.75C11.5 5.94891 11.421 6.13968 11.2803 6.28033C11.1397 6.42098 10.9489 6.5 10.75 6.5H6.5V10.75C6.5 10.9489 6.42098 11.1397 6.28033 11.2803C6.13968 11.421 5.94891 11.5 5.75 11.5C5.55109 11.5 5.36032 11.421 5.21967 11.2803C5.07902 11.1397 5 10.9489 5 10.75V6.5H0.75C0.551088 6.5 0.360322 6.42098 0.21967 6.28033C0.0790175 6.13968 0 5.94891 0 5.75C0 5.55109 0.0790175 5.36032 0.21967 5.21967C0.360322 5.07902 0.551088 5 0.75 5H5V0.75C5 0.551088 5.07902 0.360322 5.21967 0.21967C5.36032 0.0790175 5.55109 0 5.75 0Z" fill={theme === "dark" ?  "#b8b4b4" : "#3C3C3B"}/>
        </svg>
        Varsa {order}. {type === "yukleme" ? "Yükleme": "Boşaltma"} Ekle
      </div>
    </Container>
  )
}

export default AddRoute